<template>
  <div class="coordinate-axis">
    <div class="dashed-line"></div>
    <div class="left-triangle"></div>
    <div class="right-triangle"></div>
    <div class="label left-label">Low Value</div>
    <div class="label right-label">High Value</div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.coordinate-axis {
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  box-sizing: border-box;
}

.dashed-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  border-top: 2px dashed #ccc;
  z-index: 1;
}

.left-triangle {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #868897;
  z-index: 1000;
}

.right-triangle {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #868897;
  z-index: 1000;
}

.label {
  font-size: 14px;
  font-family: Arial, sans-serif;
  z-index: 2;
}

.left-label {
  left: -80px;
  position: absolute;
}

.right-label {
  right: -80px;
  position: absolute;
}
</style>
